import * as React from "react";
import { TabsLayout, TabsLayoutLink } from "../../components/tabsLayout/tabsLayout";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserList } from "./list";
import { Invite } from "./invite";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

export const ListAndInvite: React.FC = () => {
  const org = useAppSelector(selectOrg);
  const basePath = `/console/org/${org}/user/-index`;

  const links: TabsLayoutLink[] = [
    { url: `${basePath}/-list`, label: "Users" },
    { url: `${basePath}/-invite`, label: "Invite" },
  ];
  return (
    <TabsLayout links={links}>
      <Routes>
        <Route index element={<Navigate to={`-list`} />} />
        <Route path={`-list`} element={<UserList />} />
        <Route path={`-invite`} element={<Invite />} />
      </Routes>
    </TabsLayout>
  );
};
